<template>
  <v-data-table
    disable-pagination
    style="width: 100%"
    :headers="headers"
    :items="locationAdditionalCharges"
    hide-default-footer
  >
    <template v-slot:item="props">
      <tr>
        <td>{{ props.item.name }}</td>
        <td>{{ (props.item.amount / 100).toFixed() }}</td>
        <td>{{ props.item.chargeCommission ? "Yes" : "No" }}</td>
        <td>{{ props.item.enabled ? "Yes" : "No" }}</td>
        <td><v-btn x-small @click="goToLocationAdditionalCharge(props.item.id)">View</v-btn></td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "location_additional_charges",
  props: {
    locationAdditionalCharges: Array
  },
  data: function() {
    return {
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Amount", sortable: false },
        { text: "Charge Commission", sortable: false },
        { text: "Enabled", sortable: false },
        { text: "Actions", sortable: false }
      ]
    };
  },
  methods: {
    goToLocationAdditionalCharge: function(id) {
      this.$router.push(`/settings/pricing/parking_and_tolls/${id}`);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}
</style>
